import { ApolloClient, InMemoryCache } from "@apollo/client";

const N8N_GRAPHQL_ENDPOINT =
  "https://lrt225ewabcslg72dkailvnagi.appsync-api.us-east-1.amazonaws.com/graphql";

// Initialize Apollo Client for n8n workflows
export const n8nClient = new ApolloClient({
  uri: N8N_GRAPHQL_ENDPOINT,
  cache: new InMemoryCache(),
  headers: {
    "x-api-key": "da2-3rgjvrv4gnh5ndbxna6filb3be",
  },
});
